/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from "react";
import { useTheme } from "../../theme/ThemeContext";

/**
 * Button to be used in forms.
 * @param {string} variant - "primary" (default) or "outlined"
 * @param {*} props
 * @returns
 */
export default function ThemedButton({
    children,
    variant = "primary",
    style = {},
    ...props
}) {
    const { theme } = useTheme();

    const isOutlined = variant === "outlined";

    const gradientValue = `linear-gradient(90deg, ${theme.primary}, ${theme.secondary})`;

    return (
        <button
            {...props}
            style={{
                background: isOutlined ? "#fff" : gradientValue,
                color: isOutlined ? theme.primary : "#fff",
                fontWeight: 600,
                borderRadius: theme.buttonRadius,
                fontSize: 17,
                border: isOutlined
                    ? `2px solid transparent`
                    : "none",
                padding: "10px 0",
                width: "100%",
                transition: "background 0.13s, color 0.13s",
                // For gradient border:
                ...(isOutlined && {
                    backgroundImage: `linear-gradient(#fff, #fff), ${gradientValue}`,
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",
                    boxShadow: "0 2px 4px rgb(80 60 150 / 7.5%)",
                }),
                ...style
            }}
        >
            {children}
        </button>
    );
}
